var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevation = function SvgElevation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M11.647 12.663H1.774q-.468 0-.673-.408a.72.72 0 0 1 .064-.79l3.09-4.332q.21-.302.532-.466.321-.163.698-.163h2.592l3.756-4.382q.344-.398.837-.218t.493.711v8.532q0 .63-.443 1.073a1.46 1.46 0 0 1-1.073.443M3.96 5.17 1.917 8.047a.73.73 0 0 1-.49.311.74.74 0 0 1-.567-.137.73.73 0 0 1-.31-.493.74.74 0 0 1 .136-.568l2.056-2.864q.21-.302.534-.472t.7-.17h2.592L9.24.536A.71.71 0 0 1 9.754.27a.75.75 0 0 1 .551.187q.245.208.265.514a.75.75 0 0 1-.186.55L7.712 4.64q-.211.261-.514.396-.303.134-.63.134zm-.71 5.977h8.397V4.661L9.22 7.49q-.212.261-.514.396t-.63.134H5.473z"
  })));
};
export default SvgElevation;